<div
  class="border-l-4"
  [ngClass]="{
    'border-primary': active,
    'border-transparent': !active,
    'opacity-40 pointer-events-none': disabled,
  }">
  <!-- Step Header -->
  <div class="flex items-center cursor-pointer py-2" tabindex="0" (click)="activate()" (keydown)="handleKeydown($event)">
    <!-- Index / Icon -->
    <span
      class="inline-flex justify-center items-center w-12 h-12 rounded-full border mx-4 transition-colors duration-300"
      [ngClass]="{
        'bg-primary text-white': active,
        'bg-white text-black': !active,
      }">
      <i *ngIf="item.icon" class="{{ item.icon }}"></i>
      <span *ngIf="!item.icon">{{ item.value }}</span>
    </span>

    <!-- Label -->
    <span>{{ item.label }}</span>
  </div>

  <!-- Step Body with smooth expand/collapse -->
  <div class="overflow-hidden" [@expandCollapse]="active ? 'open' : 'closed'">
    <div class="mt-4 pl-8">
      <ng-content></ng-content>
    </div>
  </div>
</div>
